import { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

import Sidebar from "../../../components/sidebar/Sidebar";
import HeaderBtn from "../../../components/headerBtn/headerBtn";
import SectionContent from "../../../components/sectionContent/sectionContent";

import Vacancy from "../../../pages/recruiting/vacancyList/vacancy";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const VacancySection = () => {
  const [overflowedBtnsCount, setOverflowedBtnsCount] = useState<number>(0);
  const [isOpenGroupBtn, setIsOpenGroupBtn] = useState<boolean>(false);

  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );

  const { claims } = useSelector((state: any) => state.user.user.data);

  const buttonsContainerRef = useRef<HTMLDivElement>(null);
  const headFilterRef = useRef<any>(null);

  const sidebarWidth = isOpenSidebar ? 190 : 44;
  const headerFiltersAndSelectWidth = 525;
  const minEmptyWidthForNewBtn = 300;
  const groupBtnWidth = 70;
  const buttonWidth = 130;

  const availableButtons = [
    {
      component: (
        <HeaderBtn
          content="Настройки"
          purpose="vacancyListSettings"
          modalTitle="Настройки"
        />
      ),
    },
    (claims.includes("admin") ||
      claims.includes("recruiting:vacancy:edit")) && {
      component: (
        <HeaderBtn
          content="Создать вакансию"
          purpose="createVacancyVacant"
          modalTitle="Создать вакансию"
        />
      ),
    },
    (claims.includes("admin") ||
      claims.includes("recruiting:vacancy:export")) && {
      component: (
        <HeaderBtn
          content="Выгрузить данные"
          purpose="UnloadData"
          modalTitle="Выгрузить данные"
          hasIcon="excel"
        />
      ),
    },
    (claims.includes("admin") ||
      claims.includes("recruiting:applicationform:create")) && {
      component: (
        <HeaderBtn
          content="Создать анкету"
          purpose="newApplication"
          modalTitle="Создать анкету"
        />
      ),
    },
  ];

  const filteredAvailableButtons = availableButtons.filter(
    (btn: { component: JSX.Element }) => btn
  );

  useEffect(() => {
    if (
      filteredAvailableButtons.slice(-(overflowedBtnsCount as number)).length +
        filteredAvailableButtons.slice(
          0,
          filteredAvailableButtons.length - overflowedBtnsCount
        ).length >
      filteredAvailableButtons.length
    ) {
      setOverflowedBtnsCount(0);
    }
  }, [filteredAvailableButtons, overflowedBtnsCount]);

  const handleWindowResize = useCallback(() => {
    const allButtonsWidth =
      filteredAvailableButtons.slice(
        0,
        filteredAvailableButtons.length - overflowedBtnsCount
      ).length * buttonWidth;
    const spaceToLeftSideOfFilters =
      headFilterRef.current?.getBoundingClientRect().left;
    const windowWidth = window.innerWidth;
    const isOverflowed = JSON.parse(IS_VISIBLE_SIDEBAR as string)
      ? allButtonsWidth >
        windowWidth - headerFiltersAndSelectWidth - sidebarWidth
      : allButtonsWidth > windowWidth - headerFiltersAndSelectWidth;

    if (isOverflowed) {
      setIsOpenGroupBtn(true);
      setOverflowedBtnsCount((prevValue: number) => {
        if (overflowedBtnsCount === filteredAvailableButtons.length) {
          return prevValue;
        } else {
          return overflowedBtnsCount + 1;
        }
      });
    }
    const isEnoughtSpace = JSON.parse(IS_VISIBLE_SIDEBAR as string)
      ? spaceToLeftSideOfFilters -
          sidebarWidth -
          allButtonsWidth +
          groupBtnWidth >
        minEmptyWidthForNewBtn
      : spaceToLeftSideOfFilters - allButtonsWidth + groupBtnWidth >
        minEmptyWidthForNewBtn;
    if (isEnoughtSpace) {
      setOverflowedBtnsCount((prevValue: number) => {
        if (prevValue <= 1) {
          setIsOpenGroupBtn(false);
          return 0;
        } else return prevValue - 1;
      });
    }
  }, [
    filteredAvailableButtons,
    overflowedBtnsCount,
    sidebarWidth,
    headerFiltersAndSelectWidth,
  ]);

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);

    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);

  const displayedAvailableBtns = filteredAvailableButtons
    ?.slice(-(overflowedBtnsCount as number))
    ?.map((elem: { component: JSX.Element }, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  const displayedHeadBtns = filteredAvailableButtons
    ?.slice(0, filteredAvailableButtons.length - overflowedBtnsCount)
    ?.map((elem: { component: JSX.Element }, index: number) => {
      return elem && <div key={index}>{elem?.component}</div>;
    });

  return (
    <div className="App">
      <Sidebar />
      <SectionContent
        availableButtons={displayedAvailableBtns}
        buttonsContainerRef={buttonsContainerRef}
        headBlockChildren={displayedHeadBtns}
        isOpenGroupBtn={isOpenGroupBtn}
        pageName="vacancy"
        section="Набор персонала"
        title="Вакансии"
      >
        <div className="content__main">
          <div className="btns">
            <Link to={`/recruiting/vacancy`} className="tab">
              <div className="buttons__btn  --active">Вакансии</div>
            </Link>
            {(claims.includes("admin") ||
              claims.includes("recruiting:applicationform:view")) && (
              <Link to={`/recruiting/applicationform`} className="tab">
                <div className="buttons__btn">Анкеты</div>
              </Link>
            )}
            {(claims.includes("admin") ||
              claims.includes("projects:routes:list")) && (
              <Link to={`/recruiting/vacantroutes`} className="tab">
                <div className="buttons__btn">Вакантные маршруты</div>
              </Link>
            )}
          </div>
          <Vacancy />
        </div>
      </SectionContent>
    </div>
  );
};

export default VacancySection;
